<template>
    <div class="grid flex flex-column justify-content-center align-items-center  w-full">
        <CustomBreadcrumb class="flex align-self-start p-4"
            :items="[{ label: 'Profile Settings' }, { label: 'Experiences' }]" />
        <span class="H6-Medium block text-center mt-6">Edit your teaching information</span>

        <Form class="md:col-11 md:p-5 mt-4 pl-4">
            <h4 class="Paragraph-Medium text-left">Previous Experiences</h4>

            <div v-for="(exp, index) in experiences" :key="index" class="p-0 col-12 grid">
                <div class="col-12 md:col-6">
                    <div class="flex flex-column gap-3 pt-2">
                        <label class="Label align-self-start" :for="'institution-' + index">
                            Institution/School:
                        </label>
                        <div class="flex gap-2">
                            <Button size="small" icon="pi pi-times" severity="danger" aria-label="Cancel"
                                variant="outlined" @click="removeExperience(index)" v-if="index > 0" />
                            <InputText v-model="exp.institution" :id="'institution-' + index"
                                placeholder="Enter institution/school name" size="small" variant="filled"
                                class="w-full" />
                        </div>
                    </div>
                </div>

                <div class="col-12 md:col-6">
                    <div class="flex flex-column gap-3 pt-2">
                        <label class="Label align-self-start" :for="'experienceYears-' + index">
                            Years of teaching experience:
                        </label>
                        <InputNumber v-model="exp.yearsOfExperience" :id="'experienceYears-' + index" size="small"
                            variant="filled" class="w-full" :min="0" />
                    </div>
                </div>

                <!-- <div class="col-12 md:col-6 p-0">
                    <div class="flex justify-content-start mb-4 pt-2">
                        <Button icon="pi pi-times" severity="danger" aria-label="Cancel" variant="outlined"
                            @click="removeExperience(index)" v-if="index > 0" />
                    </div>
                </div> -->
            </div>
            <div class="flex justify-content-start mb-2 pt-4">
                <Button label="Add New" class="teal-button" @click="addExperience" />
            </div>
            <div class="col-12 flex justify-content-between p-0">
                <div class="align-items-center gap-3 p-0">
                    <Button label="Save" class="teal-button mt-6" @click="Next"
                        :disabled="!isFormValid || !isFormDirty" />
                </div>
            </div>
        </Form>
    </div>
</template>

<script setup>
import { ref, defineEmits, defineProps, watch, computed } from "vue";
import { Form } from "@primevue/forms";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import CustomBreadcrumb from '@/components/CustomBreadcrumb.vue';
// import { notifyError, notifyInfo } from "@/utils/notification";

const emit = defineEmits(["submit-experiance-info", "previous-step"]);
const props = defineProps({
    profile: {
        type: Object,
        required: true
    }
});

const experiences = ref([{ institution: "", yearsOfExperience: null }]);
const originalExperiences = ref(null);

watch(
    () => props.profile,
    (newData) => {
        if (newData) {
            const newExperiences =
                newData.experience?.map((exp) => ({
                    institution: exp.institution || "",
                    yearsOfExperience: exp.yearsOfExperience ?? null,
                })) || [{ institution: "", yearsOfExperience: null }];
            experiences.value = newExperiences;
            originalExperiences.value = JSON.parse(JSON.stringify(newExperiences));
        }
    },
    { immediate: true }
);

const addExperience = () => {
    experiences.value.push({ institution: "", yearsOfExperience: null });
};

const removeExperience = (index) => {
    experiences.value.splice(index, 1);
};

const Next = () => {
    const payload = {
        experience: experiences.value.map((exp) => ({
            institution: exp.institution,
            yearsOfExperience: exp.yearsOfExperience,
        })),
    }
    emit("update-profile", payload);
};
const isFormValid = computed(() => {
    return experiences.value.every(exp => exp.institution?.trim() && exp.yearsOfExperience !== null && exp.yearsOfExperience >= 0);
});

const isFormDirty = computed(() => {
    if (!originalExperiences.value) {
        return false;
    }
    return JSON.stringify(experiences.value) !== JSON.stringify(originalExperiences.value);
});
</script>

<style scoped>
.form {
    width: 100%;
    min-width: 60vw;
}

@media (max-width: 768px) {
    .form {
        min-width: none;
    }
}
</style>
